var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBathtubOutline = function SvgBathtubOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51705 14.2169C3.37826 13.5924 3.85348 13 4.49323 13H19.5068C20.1465 13 20.6217 13.5924 20.483 14.2169L19.7199 17.6508C19.4149 19.0234 18.1974 20 16.7913 20H7.20869C5.80259 20 4.58515 19.0234 4.28013 17.6508L3.51705 14.2169Z",
    stroke: "#151515",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14V6C6 4.89543 6.89543 4 8 4H9C10.1046 4 11 4.89543 11 6V6.27273",
    stroke: "#151515",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2961 8.06121C10.1888 7.10367 10.6432 6.12877 11.531 5.61619C12.4189 5.10361 13.4904 5.19747 14.266 5.76924L10.2961 8.06121Z",
    stroke: "#151515",
    strokeWidth: 2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBathtubOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bathtub-outline.9cbed756.svg";
export { ForwardRef as ReactComponent };